import { toast } from "react-toastify";


const originalSuccess = toast.success;
const originalError = toast.error;


const active = new Set();

function getKey(message) {
  return message; 
}


toast.success = (message, options = {}) => {
  const key = getKey(message);

  if (active.has(`success-${key}`)) return;

  active.add(`success-${key}`);

  return originalSuccess(message, {
    ...options,
    toastId: options.toastId || `success-${key}`,
    onClose: () => {
      active.delete(`success-${key}`);
      options.onClose?.();
    },
  });
};

toast.error = (message, options = {}) => {
  const key = getKey(message);

  if (active.has(`error-${key}`)) return;

  active.add(`error-${key}`);

  return originalError(message, {
    ...options,
    toastId: options.toastId || `error-${key}`,
    onClose: () => {
      active.delete(`error-${key}`);
      options.onClose?.();
    },
  });
};